<template>
  <v-container
    fluid
    class="pa-0 ma-0"
  >
    <v-row
      v-if="$route.name !== 'config-client-list'"
      no-gutters
    >
      <v-fade-transition mode="out-in">
        <v-col
          cols="12"
          class="ma-0 pa-0"
        >
          <router-view />
        </v-col>
      </v-fade-transition>
    </v-row>
    <v-row v-else>
      <v-col
        cols="12"
      >
        <v-container fluid>
          <v-row no-gutters>
            <v-col cols="12">
              <MainTitle
                title="Fiches clients"
                icon="mdi-folder-account"
                :loading="loading"
              >
                <template v-slot:end-of-toolbar>
                  <v-hover>
                    <v-btn
                      v-show="!loading && hasPermission('ROLE_CONFIG_CLIENT_EDIT')"
                      slot-scope="{ hover }"
                      rounded
                      small
                      :color="hover?'green':'black'"
                      @click="showDialogAdd"
                    >
                      <v-icon
                        dark
                        :left="!$vuetify.breakpoint.smAndDown"
                      >
                        mdi-plus-circle-outline
                      </v-icon>
                      <span class="hidden-sm-and-down">Ajouter un client</span>
                    </v-btn>
                  </v-hover>
                </template>
              </MainTitle>
            </v-col>

            <v-col
              v-if="!loading"
              cols="12"
              class="mt-3"
            >
              <v-data-table
                :headers="headers"
                :items="clients"
                :disable-filtering="true"
                :disable-sort="true"
                hide-default-footer
                class="elevation-1"
                no-data-text="Aucune fiche client trouvée"
                item-key="clientId"
              >
                <template v-slot:item.libelle="{ item }">
                  <v-avatar
                    :color="item.couleur ? item.couleur : 'transparent'"
                    size="15"
                    class="mr-3"
                  />
                  {{ item.libelle }} <span
                    v-if="item.numero && item.numero !== ''"
                    class="grey--text font-italic"
                  >({{ item.numero }})</span>
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-btn
                    v-if="hasPermission('ROLE_CONFIG_CLIENT_EDIT')"
                    text
                    @click="showDialogEditClient(item)"
                  >
                    <v-icon :left="!$vuetify.breakpoint.smAndDown">
                      mdi-pencil
                    </v-icon> <span class="hidden-sm-and-down">Modifier</span>
                  </v-btn>
                  <v-btn
                    text
                    @click="showDialogEditDossiers(item)"
                  >
                    <v-icon :left="!$vuetify.breakpoint.smAndDown">
                      mdi-file-tree
                    </v-icon> <span class="hidden-sm-and-down">Dossiers</span>
                  </v-btn>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
    <v-dialog
      v-model="dialogEdit"
      persistent
      max-width="500"
    >
      <v-card>
        <v-card-title class="headline">
          <v-avatar
            :color="dialogEditUseCouleur ? dialogEditCouleur : 'transparent'"
            size="15"
            class="mr-3"
          />
          {{ dialogMode === 'add'?'Ajout d\'un client' : 'Fiche client' }}
        </v-card-title>
        <v-card-text>
          <v-text-field
            v-model="dialogEditNomClient"
            :disabled="saving"
            class="ma-1"
            autofocus
            label="Nom du client"
          />
          <v-text-field
            v-model="dialogEditNumeroClient"
            :disabled="saving"
            class="ma-1"
            label="Numéro fiche client"
          />

          <v-switch
            v-model="dialogEditUseCouleur"
            label="Affecter une couleur"
          />

          <v-color-picker
            v-if="dialogEditUseCouleur"
            v-model="dialogEditCouleur"
            :disabled="saving"
            flat
            hide-inputs
            hide-canvas
            hide-mode-switch
            width="100%"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            :disabled="saving"
            @click="cancelAddOrEditClient"
          >
            Annuler
          </v-btn>
          <v-btn
            :disabled="!formAddOrEditValid || saving"
            :loading="saving"
            @click="confirmAddOrEditClient"
          >
            <v-icon left>
              mdi-check
            </v-icon>
            <span v-if="dialogMode === 'add'">Ajouter le client</span>
            <span v-else>Modifier le client</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogDossiersEdit"
      persistent
      max-width="500"
      scrollable
    >
      <v-card>
        <v-card-title class="headline">
          Liste des dossiers de {{ currentClient?currentClient.libelle:'Client inconnu' }}
        </v-card-title>
        <v-card-text>
          <v-row
            v-if="dossiers.length"
            no-gutters
            class="pt-3 pb-3"
          >
            <v-col
              cols="auto"
            >
              Trier par...
            </v-col>
            <v-spacer />
            <v-col
              cols="auto"
              class="pr-1 subtitle-2 font-weight-regular"
            >
              Numéro de dossier
            </v-col>
            <v-col
              cols="auto"
            >
              <v-switch
                v-model="trierParDossier"
                color="grey"
                class="ma-0 pa-0"
                hide-details
                dense
              />
            </v-col>
            <v-col
              cols="auto"
              class="subtitle-2 font-weight-regular"
            >
              Nom du dossier
            </v-col>
            <v-col cols="12">
              <v-data-table
                :headers="dossiersHeaders"
                :items="dossiers"
                no-data-text="Aucune dossier trouvé"
                :disable-filtering="true"
                :disable-sort="true"
                hide-default-footer
                hide-default-header
                class="elevation-1"
                item-key="dossierId"
                :loading="loadingDossiers"
                items-per-page="1000000"
              >
                <template v-slot:item.libelle="{item}">
                  <v-icon
                    :color="item.couleur ? item.couleur : 'grey'"
                    left
                  >
                    mdi-folder
                  </v-icon>

                  <v-progress-circular
                    v-if="item.loading"
                    :width="3"
                    :size="20"
                    :indeterminate="true"
                    color="primary"
                    class="mr-3"
                  />
                  {{ item.libelle }}
                  <span
                    v-if="item.numero"
                    class="font-italic grey--text caption"
                  >({{ item.numero }})</span>
                </template>
                <template v-slot:item.actions="{item}">
                  <v-btn
                    v-if="hasPermission('ROLE_CONFIG_CLIENT_EDIT')"
                    text
                    :disabled="loadingDossiers || item.loading"
                    @click="showDialogEditDossier(item)"
                  >
                    <v-icon>
                      mdi-pencil
                    </v-icon>
                  </v-btn>
                  <v-btn
                    v-if="hasPermission('ROLE_CONFIG_CLIENT_EDIT') && false"
                    text
                    :disabled="loadingDossiers || item.loading"
                    @click="doRemoveDossier(item)"
                  >
                    <v-icon>
                      mdi-trash-can-outline
                    </v-icon>
                  </v-btn>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn
            :disabled="loadingDossiers"
            @click="showDialogAddDossier()"
          >
            <v-icon left>
              mdi-plus
            </v-icon> Ajouter un dossier
          </v-btn>
          <v-spacer />
          <v-btn
            text
            :disabled="saving || loadingDossiers"
            @click="closeEditDossiers"
          >
            Fermer
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogDossierEdit"
      persistent
      max-width="500"
    >
      <v-card>
        <v-card-title class="headline">
          <v-avatar
            :color="dialogDossierEditUseCouleur ? dialogDossierEditCouleur : 'transparent'"
            size="15"
            class="mr-3"
          />
          {{ dialogDossierMode === 'add'?'Ajout d\'un dossier' : 'Dossier' }}
        </v-card-title>
        <v-card-text>
          <v-text-field
            v-model="dialogDossierEditNomDossier"
            :disabled="savingDossier"
            class="ma-1"
            autofocus
            label="Nom du dossier"
          />
          <v-text-field
            v-model="dialogDossierEditNumeroDossier"
            :disabled="savingDossier"
            class="ma-1"
            label="Numéro dossier"
          />

          <v-switch
            v-model="dialogDossierEditUseCouleur"
            label="Affecter une couleur"
          />

          <v-color-picker
            v-if="dialogDossierEditUseCouleur"
            v-model="dialogDossierEditCouleur"
            :disabled="savingDossier"
            flat
            hide-inputs
            hide-canvas
            hide-mode-switch
            width="100%"
          />
          <v-col
            v-if="dialogDossierMode === 'add'"
            cols="12"
            class="text-center pa-2 red--text"
          >
            Attention, une fois le dossier créé il n'est plus possible de le supprimer.
          </v-col>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            :disabled="savingDossier"
            @click="cancelAddOrEditDossier"
          >
            Annuler
          </v-btn>
          <v-btn
            :disabled="!formAddOrEditDossierValid || savingDossier"
            :loading="savingDossier"
            @click="confirmAddOrEditDossier"
          >
            <v-icon left>
              mdi-check
            </v-icon>
            <span v-if="dialogDossierMode === 'add'">Ajouter le dossier</span>
            <span v-else>Modifier le dossier</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import MainTitle from '../../Common/MainTitle'

export default {
  components: { MainTitle },
  data: () => {
    return {
      trierParDossier: true,
      dossiersUseCouleur: {},
      dossiersCouleur: {},
      updateCount: 0,
      intervalSaveDossierInt: null,
      currentClient: null,
      selectedClientId: null,
      selectedDossierId: null,
      dialogMode: null,
      dialogEditCouleur: null,
      dialogEdit: false,
      dialogEditNomClient: null,
      dialogEditNumeroClient: null,
      dialogEditUseCouleur: null,
      dialogDossiersEdit: false,
      dialogDossierMode: null,
      dialogDossierEditCouleur: null,
      dialogDossierEdit: false,
      dialogDossierEditNomDossier: null,
      dialogDossierEditNumeroDossier: null,
      dialogDossierEditUseCouleur: null,
      nouvelleTache: null,
      headers: [
        { text: 'Client', value: 'libelle', sortable: true },
        { text: 'Actions', value: 'actions', sortable: false, align: 'right' }
      ],
      dossiersHeaders: [
        { text: 'Dossiers', value: 'libelle', sortable: true },
        { text: 'Actions', value: 'actions', sortable: false, align: 'right' }
      ],
      luminosites: [
        'darken-4',
        'darken-3',
        'darken-2',
        'darken-1',
        null,
        'lighten-1',
        'lighten-2',
        'lighten-3',
        'lighten-4',
        'lighten-5'
      ]
    }
  },
  computed: {
    ...mapState('worktools/clients', ['listClientsState', 'listClientsRecords', 'editClientState']),
    ...mapState('worktools/dossiers', ['listDossiersState', 'listDossiersRecords', 'editDossiersState', 'addDossiersState', 'editDossiersState']),
    ...mapGetters('user', ['hasPermission']),
    loading () {
      return this.listClientsState === 'in-progress'
    },
    loadingDossiers () {
      return this.listDossiersState === 'in-progress'
    },
    savingDossier () {
      return this.addDossiersState === 'in-progress' || this.editDossiersState === 'in-progress'
    },
    saving () {
      return this.editClientState === 'in-progress'
    },
    dossiers () {
      let dossiers = this.updateCount > -1 && this.listDossiersRecords && this.listDossiersRecords.dossiers ? this.listDossiersRecords.dossiers : []
      let champ = this.trierParDossier ? 'numero' : 'libelle'
      return dossiers.sort((a, b) => (a[champ] > b[champ]) ? 1 : -1)
    },
    clients () {
      if (this.loading) {
        return []
      }
      return this.listClientsRecords && this.listClientsRecords.fiches ? this.listClientsRecords.fiches : []
    },
    formAddOrEditValid () {
      if (!this.dialogEditNomClient) {
        return false
      }
      if ((this.dialogEditNomClient + '').trim() === '') {
        return false
      }

      if (this.clients.filter(fiche => fiche.libelle.trim().toLowerCase() === (this.dialogEditNomClient + '').trim().toLowerCase() && fiche.clientId + '' !== this.selectedClientId + '').length) {
        return false
      }
      if (this.dialogEditNumeroClient && this.dialogEditNumeroClient.trim() !== '') {
        if (this.clients.filter(fiche => (fiche.numero || '').trim().toLowerCase() === (this.dialogEditNumeroClient + '').trim().toLowerCase() && fiche.clientId + '' !== this.selectedClientId + '').length) {
          return false
        }
      }
      return true
    },
    formAddOrEditDossierValid () {
      if (!this.dialogDossierEditNomDossier) {
        return false
      }
      if ((this.dialogDossierEditNomDossier + '').trim() === '') {
        return false
      }

      if (this.dossiers.filter(dossier => dossier.libelle.trim().toLowerCase() === (this.dialogDossierEditNomDossier + '').trim().toLowerCase() && dossier.dossierId + '' !== this.selectedDossierId + '').length) {
        return false
      }
      if (this.dialogDossierEditNumeroDossier && this.dialogDossierEditNumeroDossier.trim() !== '') {
        if (this.dossiers.filter(dossier => (dossier.numero || '').trim().toLowerCase() === (this.dialogDossierEditNumeroDossier + '').trim().toLowerCase() && dossier.clientId + '' !== this.selectedDossierId + '').length) {
          return false
        }
      }
      return true
    }
  },
  mounted () {
    this.listAllClients()
  },
  methods: {
    ...mapActions('worktools/clients', ['listAllClients', 'addClient', 'editClient']),
    ...mapActions('worktools/dossiers', ['listAllDossiersForAClient', 'addDossier', 'editDossier', 'removeDossier', 'cleanDossiersListMemory']),
    cancelAddOrEditClient () {
      this.dialogMode = null
      this.selectedClientId = null
      this.dialogEditNomClient = null
      this.dialogEditNumeroClient = null
      this.dialogEditUseCouleur = false
      this.dialogEdit = false
    },
    confirmAddOrEditClient () {
      const params = {
        libelle: this.dialogEditNomClient,
        numero: this.dialogEditNumeroClient ? this.dialogEditNumeroClient : null,
        couleur: this.dialogEditUseCouleur ? (this.dialogEditCouleur ? typeof (this.dialogEditCouleur) === 'string' ? this.dialogEditCouleur : this.dialogEditCouleur.hex : '#FF0000') : null
      }

      if (this.selectedClientId) {
        return this.editClient({ ...params, clientId: this.selectedClientId })
          .then(() => {
            this.dialogEdit = false
          })
      }
      return this.addClient(params)
        .then(() => {
          this.dialogEdit = false
        })
    },
    showDialogEditClient (item) {
      this.dialogEditNomClient = item.libelle
      this.dialogEditNumeroClient = item.numero
      this.dialogMode = 'edit'
      this.dialogEdit = true
      this.dialogEditCouleur = item.couleur
      this.dialogEditUseCouleur = !!item.couleur
      this.selectedClientId = item.clientId
    },
    showDialogAdd () {
      this.selectedClientId = null
      this.dialogEditNomClient = null
      this.dialogEditNumeroClient = null
      this.dialogEditCouleur = null
      this.dialogEditUseCouleur = false
      this.dialogMode = 'add'
      this.dialogEdit = true
    },
    cancelAddOrEditDossier () {
      this.dialogDossierMode = null
      this.selectedDossierId = null
      this.dialogDossierEditNomDossier = null
      this.dialogDossierEditNumeroDossier = null
      this.dialogDossierEditUseCouleur = false
      this.dialogDossierEdit = false
    },
    confirmAddOrEditDossier () {
      const params = {
        clientId: this.currentClient.clientId,
        libelle: this.dialogDossierEditNomDossier,
        numero: this.dialogDossierEditNumeroDossier ? this.dialogDossierEditNumeroDossier : null,
        couleur: this.dialogDossierEditUseCouleur ? (this.dialogDossierEditCouleur ? typeof (this.dialogDossierEditCouleur) === 'string' ? this.dialogDossierEditCouleur : this.dialogDossierEditCouleur.hex : '#FF0000') : null
      }

      if (this.selectedDossierId) {
        return this.editDossier({ ...params, dossierId: this.selectedDossierId })
          .then(() => {
            this.dialogDossierEdit = false
          })
      }
      return this.addDossier(params)
        .then(() => {
          this.dialogDossierEdit = false
        })
    },
    showDialogEditDossier (item) {
      this.dialogDossierEditNomDossier = item.libelle
      this.dialogDossierEditNumeroDossier = item.numero
      this.dialogMode = 'edit'
      this.dialogDossierEdit = true
      this.dialogDossierEditCouleur = item.couleur
      this.dialogDossierEditUseCouleur = !!item.couleur
      this.selectedDossierId = item.dossierId
    },
    showDialogAddDossier () {
      this.selectedDossierId = null
      this.dialogDossierEditNomDossier = null
      this.dialogDossierEditNumeroDossier = null
      this.dialogDossierEditCouleur = null
      this.dialogDossierEditUseCouleur = false
      this.dialogDossierMode = 'add'
      this.dialogDossierEdit = true
    },
    showDialogEditDossiers (client) {
      this.currentClient = client
      this.dialogDossiersEdit = true
      this.cleanDossiersListMemory()
      this.listAllDossiersForAClient({ clientId: client.clientId }).then(() => {
        this.dossiers.forEach(dossier => {
          this.$set(this.dossiersUseCouleur, dossier.dossierId, !!dossier.couleur)
          this.$set(this.dossiersCouleur, dossier.dossierId, dossier.couleur)
        })
      })
    },
    closeEditDossiers () {
      this.currentClient = null
      this.dialogDossiersEdit = false
    },
    doRemoveDossier (dossier) {
      this.$set(dossier, 'loading', true)
      this.removeDossier({
        clientId: this.currentClient.clientId,
        dossierId: dossier.dossierId
      }).finally(() => {
        this.$set(dossier, 'loading', false)
      })
    },
    saveDossier (dossier) {
      this.updateCount++
      if (!this.hasPermission('ROLE_CONFIG_CLIENT_EDIT')) {
        return
      }
      if (!dossier.libelle || dossier.libelle.trim() === '') {
        return this.doRemoveDossier(dossier)
      }
      this.$set(dossier, 'loading', true)
      this.editDossier({ clientId: this.currentClient.clientId, libelle: dossier.libelle, dossierId: dossier.dossierId, couleur: dossier.couleur }).finally(() => {
        this.$set(dossier, 'loading', false)
      })
    },
    saveColorDossier (dossier, now) {
      let couleur = this.dossiersUseCouleur[dossier.dossierId] && this.dossiersCouleur[dossier.dossierId] ? (typeof this.dossiersCouleur[dossier.dossierId] === 'string' ? this.dossiersCouleur[dossier.dossierId] : this.dossiersCouleur[dossier.dossierId].hex) : null
      this.$set(dossier, 'couleur', couleur)
      if (this.intervalSaveDossierInt) {
        clearTimeout(this.intervalSaveDossierInt)
      }
      this.intervalSaveDossierInt = setTimeout(() => {
        this.saveDossier(dossier)
      }, now === true ? 1 : 1000)
    }
  }
}
</script>
